// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ./~/react-stickynode/~/core-js/internals/object-get-own-property-symbols.js
// module id = 251
// module chunks = 0